import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { memo } from 'react';
import { Metric } from "../../../metric";
import { getMetricCellResultForClick } from "../utils/prepareResultData";
export var withAnalyticsCard = function withAnalyticsCard(metricProps) {
  return function (WrappedComponent) {
    return /*#__PURE__*/memo(function (props) {
      var _props$item = props.item,
        title = _props$item.title,
        id = _props$item.id,
        subtitle = _props$item.subtitle,
        brand = _props$item.brand,
        category = _props$item.category;
      var metricData = _objectSpread(_objectSpread({}, metricProps), {}, {
        title: title,
        id: id,
        price: subtitle,
        brand: brand,
        category: category
      });
      return /*#__PURE__*/React.createElement(Metric, {
        data: JSON.stringify(metricData),
        events: {
          headerMetric: ['handleViewSearchElementBlock', 'handleEcommerceEvent']
        },
        mode: "viewport",
        once: true,
        threshold: 0.5,
        "data-t-id": "Search-hocs"
      }, /*#__PURE__*/React.createElement(Metric, {
        asChild: true,
        data: JSON.stringify(metricData),
        events: {
          headerMetric: getMetricCellResultForClick(metricData === null || metricData === void 0 ? void 0 : metricData.element_type)
        },
        mode: "click",
        "data-t-id": "Search-hocs-1"
      }, function (_ref) {
        var dataMetricAttrs = _ref.dataMetricAttrs;
        return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
          metrics: dataMetricAttrs
        }));
      }));
    });
  };
};